﻿import { Component, EventEmitter, Input, Output } from "@angular/core";
import { HashLocationStrategy, Location, LocationStrategy, CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { DataService } from "../services/dataService";


@Component({
    selector: "jax-myworkcomponent",
    templateUrl: "./myWork.component.html"
})

export class MyWorkComponent {
    public currentUser: any;
  


    constructor(private router: Router) {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser.Security.search("vintJAXPortalAccess") >= 0) {
            this.currentUser.UserType = 1;
            if(this.currentUser.Security.search("vintJAXMyWorkView") >= 0){
                this.router.navigate(["dashboard/mywork"]);
            }
            else{
                this.router.navigate(["dashboard/searchcase"]);
            }
        }
        else if (this.currentUser.Security.search("vintJAXLimitedPortalAccess") >= 0) {
            if(this.currentUser.Security.search("vintJAXMyWorkView") >= 0){
                this.router.navigate(["dashboard/mywork"]);
            }
            else{
                this.router.navigate(["dashboard/searchcase"]);
            }
            this.currentUser.UserType = 2;
        }
        else {
            this.currentUser.UserType = 0;
        }

        localStorage.setItem("currentUser", JSON.stringify(this.currentUser));
    }
}